import {call, put, takeLatest} from "redux-saga/effects";

import {PatientsAPI} from "../../../api/patientsAPI";
import {
  RESEND_PASSWORD_REQUEST,
  RESEND_PASSWORD_SUCCESS,
  SET_TOAST
} from "../../actions";
import {ToastType} from "../../../utils/interfaces";

function* workerResendPassword(action: {
  type: string;
  payload: {
    id: number;
  };
}): Generator<any> {
  try {
    const patientId = action.payload;
    yield call(PatientsAPI.resendCode, {patientId});

    yield put({
      type: RESEND_PASSWORD_SUCCESS,
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Password was sent to the email, please check it",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Couldn't resend password, probably this patient doesn't have a treatment planned",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherResendPassword() {
  yield takeLatest(RESEND_PASSWORD_REQUEST, workerResendPassword);
}
